module.exports = __webpack_public_path__ + "img/illust-signin-man.cc942538.png";